import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Component that automatically scrolls to the top of the page when the route changes.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollableContainer =
      document.querySelector('.main-content') ||
      document.querySelector('.MuiBox-root[style*="overflowY: auto"]') ||
      document.querySelector('.MuiGrid-container');

    if (scrollableContainer) {
      scrollableContainer.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return null;
};
